import React, { useCallback } from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { STATUS_CONFIG } from "./config";
import {
  positionStatusAgGridContainer,
  positionStatusTextContent,
  positionStatusIconsContainer,
  positionStatusEllipsisText,
  positionStatusFixedElement,
} from "./styles_vanilla.css";
import { PositionStatusProps, StatusContentProps } from "./types";

const StatusContent: React.FC<StatusContentProps> = ({
  config,
  client,
  entity,
  gpMainUrl,
  positionId,
}) => {
  const handleExternalLinkClick = useCallback(() => {
    if (gpMainUrl && positionId) {
      window.open(`${gpMainUrl}/position/${positionId}`, "_blank", "noopener,noreferrer");
    }
  }, [gpMainUrl, positionId]);

  return (
    <Flex className={positionStatusAgGridContainer}>
      <Flex className={positionStatusTextContent}>
        <Text
          className={`${config.clientTextClass} ${positionStatusEllipsisText}`}
          data-testid="client-text"
        >
          {client}
        </Text>
        {config.inTextClass && (
          <Text
            className={`${config.inTextClass} ${positionStatusFixedElement}`}
            data-testid="in-text"
          >
            in
          </Text>
        )}
        {config.arrowClass && (
          <Icon
            type="arrow-right"
            className={`${config.arrowClass} ${positionStatusFixedElement}`}
            data-testid="arrow-icon"
          />
        )}
        <Text
          className={`${config.entityTextClass} ${positionStatusEllipsisText}`}
          data-testid="entity-text"
        >
          {entity}
        </Text>
      </Flex>

      <Flex className={positionStatusIconsContainer}>
        {config.showSlashIcon && config.slashIconClass && (
          <Icon type="unlink" className={config.slashIconClass} data-testid="slash-icon" />
        )}
        {config.showExternalLink && config.externalLinkIconClass && gpMainUrl && (
          <Icon
            type="external-link"
            className={config.externalLinkIconClass}
            data-testid="external-link-icon"
            onClick={handleExternalLinkClick}
            style={{ cursor: "pointer" }}
          />
        )}
      </Flex>
    </Flex>
  );
};

export const PositionStatus: React.FC<PositionStatusProps> = ({
  status,
  client,
  entity,
  gpMainUrl,
  positionId,
}) => {
  const config = STATUS_CONFIG[status];

  return (
    <Flex className={config.containerClass} data-testid={`position-status-${status}`}>
      <StatusContent
        config={config}
        client={client}
        entity={entity}
        gpMainUrl={gpMainUrl}
        positionId={positionId}
      />
    </Flex>
  );
};
